export const isDevelopment = (): boolean => {    
  return process.env.NODE_ENV === "development" || window.location.hostname === "localhost";
}; 